import Modal from 'antd/es/modal/Modal';
import classNames from 'classnames';
import FinancialsLandingPage from 'pages/dashboard/FinancialsPage/components/FinancialsLandingPage';
import React, { useState } from 'react';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import BillingPortalButton from 'components/BillingPortalButton';
import useKanmonConnect from 'hooks/useKanmonConnect';
import { message } from 'antd';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';

type Props = {
    wrapClassName?: string;
    noMargin?: boolean;
};

const PaymentFailBanner = (props: Props) => {
    const { wrapClassName, noMargin } = props;
    const [homeInfo] = useProviderHomeInfo();
    const [autoShowKanmonModal, setAutoShowKanmonModal] = React.useState(false);
    const [showPaylaterModal, setShowPaylaterModal] = useState(false);
    const [kanmonConnect, kanmonInfo, loadingKanmonConnect, refetchKanmonInfo] = useKanmonConnect();
    const [show, setShow] = useState(false);

    const handleClickPaylater = () => {
        setShowPaylaterModal(true);
    };

    React.useEffect(() => {
        if (autoShowKanmonModal && kanmonConnect) {
            setShowPaylaterModal(false);
            kanmonConnect.show();
        }
    }, [autoShowKanmonModal, kanmonConnect]);

    React.useEffect(() => {
        if (homeInfo && homeInfo.providerFailedChargeTypes && homeInfo.providerFailedChargeTypes?.length > 0) {
            setShow(true);
        }
    }, [homeInfo]);

    if (!show) {
        return null;
    }

    return (
        <div className={classNames(s.wrap, { [s.noMargin]: noMargin }, wrapClassName)}>
            <div className={s.left}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289Z" fill="#F87171" />
                </svg>
            </div>
            <div className={s.mid}>
                <div className={s.title}>Your payment method failed</div>
                <div className={s.des}>Please update your payment details to avoid service interruption — or apply
                    <span
                        onClick={handleClickPaylater}
                        className={s.link}
                    >Klarity Pay Later
                    </span>  to cover your balance and pay after reimbursement.
                </div>
            </div>
            <div className={s.right}>
                <BillingPortalButton
                    className={s.payNowBtn}
                    text="Pay now →"
                    type="text"
                    hideIcon
                />

            </div>
            <Modal
                width="90%"
                open={showPaylaterModal}
                className={`${commonS.modalFixHeightWrap} ${s.modalWrap}`}
                title="Grow your practice faster with Klarity Pay Later (Powered by Kanmon)"
                onCancel={() => {
                    setShowPaylaterModal(false);
                }}
                footer={null}
                destroyOnClose
            >
                <div className={s.modalWrap}>
                    <FinancialsLandingPage
                        onClickedApplyNow={() => {
                            refetchKanmonInfo();
                            setAutoShowKanmonModal(true);
                        }}
                        doShowKanmonModal={() => {
                            setShowPaylaterModal(false);
                            if (kanmonConnect) {
                                kanmonConnect.show();
                            } else {
                                refetchKanmonInfo();
                            }
                        }}
                        isModal
                    />
                </div>
            </Modal>
        </div>
    );
};

export default PaymentFailBanner;
